<div class="flex items-center gap-2">
  <input [attr.disabled]="disabled ? true : null" class="omcheckbox" type="checkbox" [value]="control.value" [formControl]="control" />
  <om-label *ngIf="label" [text]="label" [icon]="icon" [isRequired]="isRequired$ | async"></om-label>
</div>
<ng-container *ngIf="control.invalid && control.dirty">
  <div class="om-error-placeholder">
    <om-error [control]="control"></om-error>
  </div>
</ng-container>
